import React from 'react';
import './Service.css'
import { BiCodeAlt } from "react-icons/bi";
import { BiCrop } from "react-icons/bi";
import { IoIosBuild } from "react-icons/io";

const Service = () => {
    return (
        <div className='service'>
            <div className="container">
                <h1 className='sub-title'>My Services</h1>
                <div className="services-list">
                    <div data-aos="zoom-in-right" data-aos-duration="1000">
                        <BiCodeAlt className='icon' size= "50px" />
                        <h2>Web Design</h2>
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero laudantium minus consequuntur praesentium amet sint ipsum esse est ut officia.</p>
                        <a href="#">Learn More</a>
                    </div>
                    <div data-aos="zoom-in" data-aos-duration="1000">
                        <BiCrop className='icon' size= "50px"/>
                        <h2>UI/UX Design</h2>
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero laudantium minus consequuntur praesentium amet sint ipsum esse est ut officia.</p>
                        <a href="#">Learn More</a>
                    </div>
                    <div data-aos="zoom-in-left" data-aos-duration="1000">
                        <IoIosBuild className='icon' size= "50px"/>
                        <h2>Web Development</h2>
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero laudantium minus consequuntur praesentium amet sint ipsum esse est ut officia.</p>
                        <a href="#">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service;